import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import Isvg from 'react-inlinesvg'
import { Field, reduxForm, SubmissionError } from 'redux-form'

import loginActions from 'redux/actions/loginActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { MainButton, BaseButton } from 'components/button'
import { loginSelectors } from 'redux/selectors'
import TextLink from 'components/text_link/text_link'
import TextInputForm from 'components/input/text/text_input_form'
import CheckboxInputForm from 'components/input/checkbox/checkbox_input_form'
import { ssoRedirect } from 'helpers/functions'
import { localize } from 'helpers/translator'
import SignupStudent from 'views/signup/student/view'
import LoginHeader from 'views/login/header/login_header'
import Redirection from 'decorators/authentication/Redirection'

import styles from './login_main_unified.scss'
import googleIcon from 'assets/views/signup/google-icon.svg'
import msIcon from 'assets/views/signup/ms-icon.svg'

const validate = values => {
	const errors = {}
	if (!values.email) {
		errors.email = localize('global_form_emailIsRequired')
		errors._error = localize('global_form_emailIsRequired')
	}
	if (!values.password) {
		errors.password = localize('global_form_passwordIsRequired')
		errors._error = localize('global_form_emailIsRequired')
	}
	return errors
}

class LoginMainUnified extends PureComponent {

	constructor() {
		super()
		this.navigateToSignUp = this.navigateTo.bind(this, 'signup')
		this.resetLoginAuthentication = this.resetLoginAuthentication.bind(this)
		this.handleLoginSubmit = this.handleLoginSubmit.bind(this)
		this.getFieldStatus = this.getFieldStatus.bind(this)
		this.getFieldMessage = this.getFieldMessage.bind(this)
		this.googleSsoRedirectHandler = this.ssoRedirectHandler.bind(this, 'google')
		this.officeSsoRedirectHandler = this.ssoRedirectHandler.bind(this, 'office')
	}

	navigateTo() {
		this.props.actions.navigateToSignUp()
	}

	componentDidMount() {
		this.props.actions.loginInitialize(location.search)
	}

	resetLoginAuthentication(input, value) {
		input.onChange(value)
		if (this.props.authenticationFailed) {
			this.props.actions.resetLoginAuthentication()
		}
	}

	handleLoginSubmit(values) {
		return new Promise((resolve, reject) => {
			this.props.actions.sendLoginForm(values, resolve, reject)
		})
			.then(() => {})
			.catch(function(err) {
				throw new SubmissionError({...err})
			})
	}

	getFieldStatus(field) {
		if (field.touched && field.invalid &&
		(this.props.authenticationFailed || this.props.error)) {
			return 'error'
		} else {
			return ''
		}
	}

	getFieldMessage(field, name) {
		return this.props.authenticationFailed ? name === 'password' ? field.error : '' : localize(field.error)
	}

	ssoRedirectHandler(service) {
		const url = ssoRedirect(service)
		this.props.actions.ssoRedirect(
			url,
			this.props.isInIframe,
			this.props.fromLTI
		)
	}

	onForgotPassword = () => {
		this.props.actions.onForgotPassword(this.props.shouldOpenInNewTab)
	}

	componentWillUnmount() {
		this.props.actions.loginFinalize()
	}

	render() {
		if (this.props.isUserLogged) {
			return null
		}

		let forgotPasswordTarget = null
		if (this.props.shouldOpenInNewTab) {
			forgotPasswordTarget = '_blank'
		}

		const {
			handleSubmit,
			submitting,
		} = this.props

		return (
			<div styleName='wrapper'>
				{!this.props.shouldHideHeaderLogo &&
					<div styleName='header'>
						<LoginHeader
							canLinkToHome={this.props.canLinkToHome}
						/>
					</div>
				}
				<div styleName='content'>
					<div styleName='content-wrapper'>
						<div styleName='teacher'>
							<h1 styleName='teacher-title'>{localize('logIn_title_2')}</h1>
							<h2 styleName='teacher-subtitle'>{localize('logIn_subtitle')}</h2>
							{!this.props.shouldHideGoogleSso &&
								<div styleName='teacher-button'>
									<MainButton
										pill={true}
										onClick={this.googleSsoRedirectHandler}
									>
										<Isvg src={googleIcon} cacheGetRequests={true} styleName='teacher-button-icon' />
										{ localize('logIn_logInWithGoogle') }
									</MainButton>
								</div>
							}
							{!this.props.shouldHideOfficeSso &&
								<div styleName='teacher-button'>
									<BaseButton
										bgColor='red'
										pill={true}
										fontColor='white'
										onClick={this.officeSsoRedirectHandler}
									>
										<Isvg src={msIcon} cacheGetRequests={true} styleName='teacher-button-icon' />
										{ localize('logIn_logInWithOffice') }
									</BaseButton>
								</div>
							}
							{this.props.shouldShowDividerLine &&
								<p styleName='teacher-separator'>{localize('signup_teacher_separator')}</p>
							}
							<form styleName='teacher-form' onSubmit={handleSubmit(this.handleLoginSubmit)}>
								<div styleName='teacher-form-field'>
									<Field
										name="email"
										component={TextInputForm}
										type="text"
										props={{
											placeholder: localize('global_form_email'),
											disabled: submitting,
											fieldStatus: this.getFieldStatus,
											getMessage: this.getFieldMessage,
											onInput: this.resetLoginAuthentication,
											icons: {active: true},
										}}
									/>
								</div>
								<div styleName='teacher-form-field'>
									<Field
										name="password"
										component={TextInputForm}
										type="password"
										props={{
											placeholder: localize('global_form_password'),
											fieldStatus: this.getFieldStatus,
											getMessage: this.getFieldMessage,
											onInput: this.resetLoginAuthentication,
											icons: {active: true},
										}}

									/>
								</div>
								<div styleName='teacher-form-password'>
									<Field
										name="remember"
										component={CheckboxInputForm}
										type="checkbox"
									/>
									<label styleName='teacher-form-label'>
										{localize('logIn_rememberMe')}
										<TextLink
											styleName='teacher-form-password-link'
											target={forgotPasswordTarget}
											to={'/forgot_password' + location.search}
											onMouseUp={this.onForgotPassword}
										>
											{localize('logIn_forgotPassword_question')}
										</TextLink>
									</label>
								</div>
								<div styleName='teacher-form-button'>
									<MainButton type='submit' pill={true} disabled={submitting}>
										{localize('global_logIn')}
									</MainButton>
								</div>
							</form>
							{this.props.fromLTI !== '1' &&
								<p styleName='teacher-text'>
									{ localize('logIn_signUp_label_2') }
									<TextLink
										styleName='teacher-text-link'
										to={'/signup'+location.search}
										linkClick={this.navigateToSignUp}
									>
										{localize('global_signUp')}
									</TextLink>
								</p>
							}
						</div>
						{this.props.canActAsStudent &&
							<div styleName='student'>
								<SignupStudent
									shouldShowSso={this.props.shouldShowStudentSso}
									googleLoginSuccess={this.props.actions.studentGoogleLoginSuccess}
									googleLoginFailed={this.props.actions.studentGoogleLoginFailed}
									office365LoginSuccess={this.props.actions.studentOffice365LoginSuccess}
									office365LoginFailed={this.props.actions.studentOffice365LoginFailed}
								/>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

LoginMainUnified.propTypes = {
	actions: PropTypes.object,
	authenticationFailed: PropTypes.bool,
	fromLTI: PropTypes.string,
	canActAsStudent: PropTypes.bool,
	handleSubmit: PropTypes.func,
	error: PropTypes.string,
	submitting: PropTypes.bool,
	isInIframe: PropTypes.bool,
	shouldHideGoogleSso: PropTypes.bool,
	shouldHideOfficeSso: PropTypes.bool,
	shouldOpenInNewTab: PropTypes.bool,
	shouldShowDividerLine: PropTypes.bool,
	shouldHideHeaderLogo: PropTypes.bool,
	isUserLogged: PropTypes.bool,
	canLinkToHome: PropTypes.bool,
	shouldShowStudentSso: PropTypes.bool,
}

LoginMainUnified.defaultProps = {
	canActAsStudent: true,
	isInIframe: false,
	shouldHideGoogleSso: false,
	shouldHideOfficeSso: false,
	shouldHideHeaderLogo: false,
	isUserLogged: false,
	canLinkToHome: true,
	shouldShowStudentSso: false,
	fromLTI: '0',
}

function mapStateToProps(state) {
	const loginMainUnifiedSelector = loginSelectors.loginMainUnifiedSelector(state)
	return {
		...loginMainUnifiedSelector,
		initialValues: {
			email: loginMainUnifiedSelector.email,
			remember: true,
		},
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		navigateToSignUp: loginActions.navigateToSignUp,
		resetLoginAuthentication: loginActions.resetLoginAuthentication,
		sendLoginForm: loginActions.sendLoginForm,
		ssoRedirect: loginActions.ssoRedirect,
		onForgotPassword: loginActions.onForgotPassword,
		loginInitialize: loginActions.loginInitialize,
		loginFinalize: loginActions.loginFinalize,
		studentGoogleLoginSuccess: loginActions.studentGoogleLoginSuccess,
		studentGoogleLoginFailed: loginActions.studentGoogleLoginFailed,
		studentOffice365LoginSuccess: loginActions.studentOffice365LoginSuccess,
		studentOffice365LoginFailed: loginActions.studentOffice365LoginFailed,
	}, dispatch)
}

export default Redirection(connect(
	mapStateToProps,
	mapDispatchToProps,
)(reduxForm({
	form: 'Login',
	fields: ['email', 'password', 'remember'],
	validate,
})(CSSModules(LoginMainUnified, styles, {allowMultiple: true}))))
